// extracted by mini-css-extract-plugin
export default {"formErrorMain":"style_formErrorMain__ySyOu","formError":"style_formError__PhJcb"};